import React from 'react';

export default function ShowIf({ condition, children }) {
  const outputJSX = condition ? children : null;
  return (
    <>
      { outputJSX }
    </>
  );
}
